'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isInteger = require('babel-runtime/core-js/number/is-integer');

var _isInteger2 = _interopRequireDefault(_isInteger);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _flexboxgrid = require('flexboxgrid');

var _flexboxgrid2 = _interopRequireDefault(_flexboxgrid);

var _Col = require('./Col.scss');

var _Col2 = _interopRequireDefault(_Col);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Col = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Col, _Component);

  function Col() {
    (0, _classCallCheck3.default)(this, Col);
    return (0, _possibleConstructorReturn3.default)(this, (Col.__proto__ || (0, _getPrototypeOf2.default)(Col)).apply(this, arguments));
  }

  (0, _createClass3.default)(Col, [{
    key: '_getModifiers',
    value: function _getModifiers() {
      var mods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var classMap = {
        reverse: 'reverse',
        xs: 'col-xs',
        sm: 'col-sm',
        md: 'col-md',
        lg: 'col-lg',
        xsOffset: 'col-xs-offset',
        smOffset: 'col-sm-offset',
        mdOffset: 'col-md-offset',
        lgOffset: 'col-lg-offset'
      };

      return (0, _keys2.default)(mods).filter(function (key) {
        return classMap[key];
      }).map(function (key) {
        var _mod = mods[key];
        var _class = classMap[key];

        if (_mod === undefined) return '';

        return _flexboxgrid2.default[(0, _isInteger2.default)(_mod) ? _class + '-' + _mod : _class];
      }).join(' ');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          tag = _props.tag,
          children = _props.children,
          className = _props.className,
          reverse = _props.reverse,
          xs = _props.xs,
          sm = _props.sm,
          md = _props.md,
          lg = _props.lg,
          xsOffset = _props.xsOffset,
          smOffset = _props.smOffset,
          mdOffset = _props.mdOffset,
          lgOffset = _props.lgOffset,
          rest = (0, _objectWithoutProperties3.default)(_props, ['tag', 'children', 'className', 'reverse', 'xs', 'sm', 'md', 'lg', 'xsOffset', 'smOffset', 'mdOffset', 'lgOffset']);

      var Tag = tag;

      var _className = (0, _classnames2.default)(className, _Col2.default.col, _flexboxgrid2.default.col, this._getModifiers({ reverse: reverse, xs: xs, sm: sm, md: md, lg: lg, xsOffset: xsOffset, smOffset: smOffset, mdOffset: mdOffset, lgOffset: lgOffset }));

      return _react2.default.createElement(
        Tag,
        (0, _extends3.default)({}, rest, { className: _className }),
        children
      );
    }
  }]);
  return Col;
}(_react.Component), _class2.propTypes = {
  reverse: _react.PropTypes.bool,
  xs: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  sm: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  md: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  lg: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.bool]),
  xsOffset: _react.PropTypes.number,
  smOffset: _react.PropTypes.number,
  mdOffset: _react.PropTypes.number,
  lgOffset: _react.PropTypes.number,
  tag: _react.PropTypes.string,
  children: _react.PropTypes.node,
  className: _react.PropTypes.string
}, _class2.defaultProps = {
  tag: 'div'
}, _temp);
exports.default = Col;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseGrid/Col/Col.jsx
// module id = 1586
// module chunks = 0